import React from 'react';
import type { StartupInterestedInvestorItem } from '../../types/startupDashboard';
import heartIcon from '../../assets/favorites_icon_(green heart).png';
import DashboardSectionTab from './DashboardSectionTab';
import InterestedInvestorCard from './InterestedInvestorCard';
import { PrairiScrollbar } from '../profile/PrairiScrollbar';

interface InterestedInvestorsPanelProps {
  investors: StartupInterestedInvestorItem[];
  onResponseSubmitted?: (investorId: string) => void;
  selectedInvestorId?: string | null;
  selectionTimestamp?: number;
  hideHeader?: boolean;
}

const InterestedInvestorsPanel: React.FC<InterestedInvestorsPanelProps> = ({
  investors,
  onResponseSubmitted,
  selectedInvestorId,
  selectionTimestamp,
  hideHeader = false,
}) => {
  const panelScrollRef = React.useRef<HTMLDivElement>(null);
  const panelRef = React.useRef<HTMLDivElement>(null);

  return (
    <section className="flex h-full min-h-[280px] flex-col">
      {!hideHeader && (
        <div className="mb-6 flex shrink-0 justify-center pt-2">
          <DashboardSectionTab
            label="Interested"
            count={investors.length}
            variant="interested"
            iconSrc={heartIcon}
            iconAlt=""
          />
        </div>
      )}

      {investors.length === 0 ? (
        <div className="flex flex-1 flex-col items-center justify-center gap-3 rounded-xl border border-gray-800 bg-[#171717] px-4 py-10 text-center">
          <img src={heartIcon} alt="" className="h-8 w-8 object-contain opacity-35" aria-hidden />
          <p className="text-sm text-gray-400">No investors yet</p>
          <p className="max-w-[260px] text-xs leading-relaxed text-gray-500">
            When an investor favorites you and agrees to share their contact info, they will appear
            here.
          </p>
        </div>
      ) : (
        <div ref={panelRef} className="relative flex-1 min-h-0">
          <div
            ref={panelScrollRef}
            className="prairi-hide-native-scrollbar max-h-[calc(100vh-12rem)] overflow-y-auto space-y-4 pr-1"
          >
            {investors.map(investor => (
              <InterestedInvestorCard
                key={investor.id}
                investor={investor}
                onResponseSubmitted={onResponseSubmitted}
                selectedInvestorId={selectedInvestorId || undefined}
                selectionTimestamp={selectionTimestamp}
              />
            ))}
          </div>
          <PrairiScrollbar
            scrollRef={panelScrollRef}
            hoverRootRef={panelRef}
            thumbHeight={40}
            thumbWidth={6}
            trackInsetY={10}
            outside
          />
        </div>
      )}
    </section>
  );
};

export default InterestedInvestorsPanel;
